import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-profile-user',
  imports: [],
  templateUrl: './icon-bold-profile-user.html',
  standalone: true,
  styleUrl: './icon-bold-profile-user.css'
})
export class IconBoldProfileUser {
  @Input() color = 'black';
  @Input() size = '16';
}
